import React, { useEffect, useState } from 'react'
import { ChatDesktopContainer } from './style'
import { useViews } from 'state'
import { useSelector } from 'react-redux'
import { selectCurrentStore } from '../../reducers/storeSlice'
import { CALL_ACTION_CAMERAS, selectActiveCallAction } from '../../reducers/uiSlice'
import { ChatModule } from './ChatModule'
import { LaptopCameras } from '../GJKit/Cameras/LaptopCameras'
import { useAuth } from '@gojiraf/auth'
import AskNameDialog from '../dialogs/AskNameDialog'

export const ChatDesktop = () => {
  const [chatOpen, setChatOpen] = useState(true)
  const { user } = useAuth()
  const { state, send } = useViews()
  const { isOneToManySale, storeConfigurations } = useSelector(selectCurrentStore)
  const activeCard = useSelector(selectActiveCallAction)

  useEffect(() => {
    if (activeCard === CALL_ACTION_CAMERAS) {
      send({ type: 'SHOW_PARTICIPANTS' })
    } else {
      send({ type: 'SHOW_CHAT' })
    }
  }, [])

  return (
    <ChatDesktopContainer>
      {!isOneToManySale && (
        <LaptopCameras
          style={{ display: state.matches('secondary.showingParticipants') === true ? '' : 'none' }}
          allowsMultipleBuyers={storeConfigurations.allowsMultipleBuyers}
        />
      )}
      {state.matches('secondary.showingChat') === true && (
        <ChatModule isDesktop chatOpen={chatOpen} setChatOpen={setChatOpen} user={user} />
      )}
      <AskNameDialog />
    </ChatDesktopContainer>
  )
}
